import { useEffect } from 'react';
import { Outlet, useLoaderData, useLocation, useNavigation } from 'react-router';
import { AppSidebar } from '@/components/app-sidebar';
import { api, setSession, type SessionResponse } from '@/lib/api';
import { posthog, posthogEnabled } from '@/lib/posthog';

/**
 * Layout route for everything behind login. The loader replaces the old Next
 * middleware: no valid session (after one refresh attempt) → redirect to /login.
 */
export async function sessionLoader() {
  const session = await api<SessionResponse>('/auth/session');
  setSession(session);
  return session;
}

export function AppShell() {
  const { user } = useLoaderData<typeof sessionLoader>();
  const location = useLocation();
  const navigation = useNavigation();

  useEffect(() => {
    if (posthogEnabled) posthog.capture('$pageview', { $current_url: window.location.href });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen">
      <AppSidebar user={user} />
      <main className={`min-w-0 flex-1 p-6 lg:p-8 ${navigation.state === 'loading' ? 'opacity-70 transition-opacity delay-200' : ''}`}>
        <Outlet />
      </main>
    </div>
  );
}
